export enum ResourcePlanningFilterType{
    PLANNER_BOARD = "PLANNER_BOARD"
}